// extracted by mini-css-extract-plugin
export default {"content":"styles_content__+kpxu","image":"styles_image__C1TIR"};